import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { CategoriesProvider } from './context/CategoriesContext';
import { ToastProvider } from './context/ToastContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { initializeAuth, useAuthStore } from './stores/authStore';
import LoadingComponent from './components/Common/LoadingComponent';
import './App.css';
import { AppRoutes } from './routes/AppRoutes';
import ScrollToTop from './components/Common/ScrollToTop';
import { CookieBanner } from './components/Common/CookieBanner';

function App() {
  const [isInitializing, setIsInitializing] = useState(true);
  const isInitialized = useAuthStore((state) => state.isInitialized);

  // Initialize auth store on app start
  useEffect(() => {
    const init = async () => {
      try {
        await initializeAuth();
      } catch (error) {
        console.error('Auth initialization error:', error);
      } finally {
        setIsInitializing(false);
      }
    };

    init();
  }, []);

  // Show loading screen while initializing auth
  if (isInitializing || !isInitialized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#1A1A2E'
      }}>
        <LoadingComponent
          style="spinner" // eslint-disable-line react/style-prop-object
          color="#C5A06A"
          size="large"
          text="Yükleniyor..."
          showLogo={false}
        />
      </div>
    );
  }

  return (
    <ToastProvider>
      <NotificationProvider>
        <CategoriesProvider>
          <Router>
            <ScrollToTop />
            <CookieBanner />
            <AppRoutes />
          </Router>
        </CategoriesProvider>
      </NotificationProvider>
    </ToastProvider>
  );
}

export default App;